var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 bg-white"},[_c('shared-transfers-history',{attrs:{"transferLogs":_vm.transferLogs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }